import { render } from "./AboutCtaComp.vue?vue&type=template&id=91113b00&scoped=true"
import script from "./AboutCtaComp.vue?vue&type=script&lang=js"
export * from "./AboutCtaComp.vue?vue&type=script&lang=js"

import "./AboutCtaComp.vue?vue&type=style&index=0&id=91113b00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91113b00"]])

export default __exports__